import AuthLayoutComponent from '@/components/layouts/auth-layout/auth-layout.component';
import {RouteConfig} from 'vue-router';
import AccountCreationComponent from '../accountCreation/accountCreation.component';
import ForgotPasswordComponent from '../forgot-password/forgot-password.component';
import SigninComponent from '../login/signin.component';
import PhoneVerificationComponent from '../phone-verification/phone-verification.component';
import ResetPasswordComponent from '../reset-password/reset-password.component';
import SignupComponent from '../signup/signup.component';

export const AuthenticationRoutes: Array<RouteConfig> = [
    {
        path: '/auth',
        name: 'auth',
        component: AuthLayoutComponent,
        redirect(to) {
            return {name: 'signin'};
        },
        children: [
            {
                path: 'signin',
                name: 'signin',
                component: SigninComponent,
            },
            {
                path: 'signup',
                name: 'signup',
                component: SignupComponent,
            },
            {
                path: 'forgot-password',
                name: 'forgotPassword',
                component: ForgotPasswordComponent,
            },
            {
                path: 'phone-verification',
                name: 'phoneVerification',
                component: PhoneVerificationComponent,
            },
            {
                path: 'reset-password',
                name: 'resetPassword',
                component: ResetPasswordComponent,
            },
            {
                path: '/accountCreation',
                name: 'accountCreation',
                component: AccountCreationComponent,
            },
        ],
    },
];
